export default "__VITE_ASSET__79fd9cd5__"